/**
 * The six Brushes. The order is the rail's order and the keys are 1 to 6:
 * kick, snare, hat, tom, Wall, eraser, fixed by the break-slices plan and
 * superseding the spec's list. A Brush is nothing but the value it writes into
 * a Cell; erasing is a Brush like any other, and the only one that writes 0.
 */

import { EMPTY, HAT, KICK, SNARE, TOM, WALL } from "./world.ts"

export interface Brush {
  /** Shown on the rail, and the class its glyph is drawn with. */
  readonly name: string
  readonly key: string
  readonly value: number
}

export const BRUSHES: ReadonlyArray<Brush> = [
  { name: "kick", key: "1", value: KICK },
  { name: "snare", key: "2", value: SNARE },
  { name: "hat", key: "3", value: HAT },
  { name: "tom", key: "4", value: TOM },
  { name: "wall", key: "5", value: WALL },
  { name: "eraser", key: "6", value: EMPTY }
]

export const brushForKey = (key: string): Brush | undefined => BRUSHES.find((brush) => brush.key === key)
